import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({})
class NotFound extends Vue {}
export default toNative(NotFound);
